export default "__VITE_ASSET__0d21b087__"